import { Component, Input } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-display-text',
  templateUrl: './display-text.component.html',
  styleUrls: ['./display-text.component.scss']
})
export class DisplayTextComponent extends DialogContentBase {

  constructor( 
    public dialog: DialogRef,
    ) {   super(dialog);  }

  @Input() label:string;
  @Input() selectedText:string;
  @Input() formatXmlContent = false;
  

  close(){
        this.dialog.close({ text: 'OK' });
  }

}
